import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {LoginRequiredCallback} from '@common/messe-ui-toolkit';
import {MarkantElementsModule} from '@markant/elements-angular';

@Component({
  selector: 'app-login-required-dialog',
  templateUrl: './login-required-dialog.component.html',
  styleUrls: ['login-required-dialog.component.scss'],
  standalone: true,
  imports: [MarkantElementsModule],
})
export class LoginRequiredDialogComponent implements OnInit {
  private loginRequired?: Subject<boolean>;

  open = false;

  constructor(private readonly loginRequiredCallback: LoginRequiredCallback) {}

  ngOnInit(): void {
    this.loginRequiredCallback.registerListener(() => {
      if (this.loginRequired) {
        this.loginRequired.complete();
      }
      this.loginRequired = new Subject<boolean>();
      this.open = true;
      return this.loginRequired.asObservable();
    });
  }
  onLoginAccepted() {
    this.loginRequired?.next(true);
    this.loginRequired?.complete();
    this.open = false;
  }

  onLoginRejected() {
    this.loginRequired?.next(false);
    this.loginRequired?.complete();
    this.open = false;
  }
}
